exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatars {\n  margin-left: 0.75rem;\n}\n.avatars > .avatar {\n  margin-left: -0.75rem;\n}\n.avatars > .v-popover {\n  margin-left: -0.75rem;\n  position: relative;\n  align-items: flex-start;\n  display: inline-flex;\n  vertical-align: top;\n}", ""]);

// exports
